import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
const GoogleDriveFolder = (props) => {
    const iconProps = useIconProps(props);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: _jsxs("g", { children: [_jsx("path", { d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" }), _jsx("path", { d: "M0 0h24v24H0z", fill: "none" })] }) })));
};
export default GoogleDriveFolder;
